import { Tag } from "@/constants/tip";
import { Axios } from "@/utils/axios";
import GuidebookContainer from "containers/GuidebookContainer";
import { Category } from "@/types/guidebookType";
import { GetStaticProps } from "next";

export const getStaticProps: GetStaticProps = async () => {
  const { data } = await Axios.get("/articles/");

  return {
    props: {
      articles: data,
      pageOgTitle: "장례에 대한 모든 지식, 고이 장례 가이드북",
      pageDescription:
        "장례 절차와 일정, 상조 서비스 유형과 비용 등 장례에 필요한 모든 정보를 확인하세요.",
      pageOgDescription:
        "장례 절차와 일정, 상조 서비스 유형과 비용 등 장례에 필요한 모든 정보를 확인하세요.",
      pageKeywords:
        "장례, 장례식, 가족장, 무빈소장례, 장례지도사, 장례식장, 장례 비용, 고이, 고이장례연구소, 상조, 상조 회사, 상조회, 상조가입, 상조추천, 후불제상조, 장례상조, 상조서비스, 장례식 절차, 장례 절차, 임종, 고인, 빈소, 임종",
    },
  };
};

export interface ArticleSummary {
  title: string;
  type: "tip";
  index: string;
  tag: Tag;
  category: Category;
  date: string;
}

function GuidebookMain({ articles }: { articles: ArticleSummary[] }) {
  return <GuidebookContainer articles={articles} />;
}

export default GuidebookMain;
